import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface EmployeeCountRecord {
  symbol: string;
  periodOfReport: string;
  filingDate: string;
  employeeCount: number;
  companyName: string;
  lastUpdated: string;
}

export const useCompanyEmployeeCount = (ticker: string | undefined, limit?: number) => {
  return useQuery<EmployeeCountRecord[], Error>({
    queryKey: ['companyEmployeeCount', ticker, limit],
    queryFn: async () => {
      if (!ticker) {
        throw new Error('Ticker is required');
      }

      const params: any = { ticker };
      if (limit) {
        params.limit = limit.toString();
      }
      
      const { data } = await api.get<EmployeeCountRecord[]>('/company-employee-count', {
        params,
      });
      return data;
    },
    enabled: !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 2.5 * 60 * 1000, // 2.5 minutes for fresh data
    retry: (failureCount, error) => {
      // Don't retry on 404s - legitimately means no employee count data exists
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((error as any)?.response?.status === 404) {
        return false;
      }
      // Retry other errors (500s, network issues) max 2 times
      return failureCount < 2;
    },
  });
};